import { render, staticRenderFns } from "./producer_submit_select_tasting.vue?vue&type=template&id=58ed737d&scoped=true"
import script from "./producer_submit_select_tasting.vue?vue&type=script&lang=js"
export * from "./producer_submit_select_tasting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ed737d",
  null
  
)

export default component.exports